import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { cardHover } from 'src/theme/customEffects'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    
    card: {
      marginBottom: theme.spacing(2),
      '&.hover': cardHover(theme),
    },

    content: {},

    /* ********************************************** */
    gridRoot: {
      display: 'grid',
      //gap: theme.spacing(4),

      gridTemplateAreas: `
        "img inf"
      `,

      gridTemplateColumns: '150px auto',
    },
    /* ********************************************** */

    gridInfos: {
      display: 'grid',
      //gap: theme.spacing(4),

      gridTemplateAreas: `
        "tit"
        "pri"
        "des"
        "btn"
      `,

      [theme.breakpoints.up(700)]: {
        gridTemplateAreas: `
          "tit pri"
          "des pri"
          "btn btn"
        `,
        gridTemplateColumns: 'auto min-content',
        gridTemplateRows: 'min-content auto min-content',
      },
    },

    /* ********************************************** */

    image: {
      gridArea: 'img',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      marginRight: theme.spacing(2),
      position: 'relative',
      cursor: 'pointer',
      width: 140,
      '& > img': {
        padding: 5,
        maxHeight: 190,
        objectFit: 'contain',
      }
    },

    titel: {
      gridArea: 'tit',
      marginBottom: theme.spacing(1),
      cursor: 'pointer',
      '& > a': {
        color: 'inherit',
        textDecoration: 'inherit',
      }
    },

    description: {
      gridArea: 'des',
      marginBottom: theme.spacing(1),
      '& > ul': {
        padding: 0,
        '& > li': {
          display: 'block',
          padding: 0,
        },
      },
    },

    price: {
      gridArea: 'pri',
      marginBottom: theme.spacing(1),
      //textAlign: 'right',
      whiteSpace: 'nowrap',
    },

    discountInfos: {
      
    },

    buttons: {
      gridArea: 'btn',
      marginTop: theme.spacing(1),
      display: 'grid',
      gap: theme.spacing(1),

      gridTemplateColumns: '1fr',
      '& > div:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },

      [theme.breakpoints.up(465)]: {
        gridTemplateColumns: 'repeat(2, max-content)',
        '& > div:not(:last-child)': {
          marginBottom: theme.spacing(0),
        },
      },

      '& > div > button': {
        marginRight: theme.spacing(1),
      },
    },

  })
)

export default useStyles
